import React from 'react';
import { useDataroomTenantContext } from '@dataroom/tenant/DataroomTenantContext';
import AlertsComponent from '@dataroom/email-alerts/ui/Alerts';
import DateTime from '@dealroadshow/uikit-date-time';
import { getTitle, getDescription } from './constants';
import { AlertsType } from './AlertsType';
import { ITimezone } from '@framework/timezone/vo/Timezone';
import { IFileUploadNotificationSettingsPayload } from '@dataroom/email-alerts/domain/vo/FileUploadEmailAlerts';
import { IStagingFileUploadNotificationSettingsPayload } from '@dataroom/email-alerts/domain/vo/StagingFileUploadEmailAlerts';
import { IAccessRequestNotificationSettingsPayload } from '@dataroom/email-alerts/domain/vo/AccessRequestEmailAlerts';
import styles from './alerts.module.scss';

interface IProps<T = IFileUploadNotificationSettingsPayload |
  IStagingFileUploadNotificationSettingsPayload |
  IAccessRequestNotificationSettingsPayload,
> {
  name: string,
  alertType: AlertsType,
  initialValues: T,
  timezone: ITimezone,
  withTimezoneLabel?: boolean,
  onChange: (v: T) => void,
  isFetching: boolean,
}

const Alerts = ({
  name,
  alertType,
  initialValues,
  timezone,
  withTimezoneLabel,
  onChange,
  isFetching,
}: IProps) => {
  const { tenant } = useDataroomTenantContext();
  const timeZoneDisplayName = withTimezoneLabel && timezone ? new DateTime({ timeZone: timezone }).getTimeZoneDisplayName() : '';

  return (
    <>
      <div className={ styles.title }>
        <p className={ styles.timezone }>{ timeZoneDisplayName }</p>
        <p className={ styles.sectionTitle }>{ getTitle(alertType) }</p>
      </div>
      <div className={ styles.container }>
        <div className={ styles.alertsTitle }>
          { getDescription(alertType, tenant) }
        </div>
        <AlertsComponent
          name={ name }
          initialValues={ initialValues }
          timezone={ timezone }
          onChange={ onChange }
          isFetching={ isFetching }
        />
      </div>
    </>
  );
};

export default Alerts;
